// 渲染地圖 POI
import { PlaceWithServices } from '../../../models/Place.ts';
import React from 'react';
import { AdvancedMarker, useMap } from '@vis.gl/react-google-maps';
import PlaceServicesSummary from './PlaceServicesSummary.tsx';
import { flushSync } from 'react-dom';

const ICON_SIZE = 40;

// 先生成所有類型的 icon
const iconCache: Record<string, string> = {
  generalIcon: createCustomIcon('generalIcon'),
  generalIconSelected: createCustomIcon('generalIconSelected'),
  charging: createCustomIcon('charging'),
  chargingSelected: createCustomIcon('chargingSelected'),
  fueling: createCustomIcon('fueling'),
  fuelingSelected: createCustomIcon('fuelingSelected'),
  parking: createCustomIcon('parking'),
  parkingSelected: createCustomIcon('parkingSelected'),
  maintenance: createCustomIcon('maintenance'),
  maintenanceSelected: createCustomIcon('maintenanceSelected'),
  inspection: createCustomIcon('inspection'),
  inspectionSelected: createCustomIcon('inspectionSelected'),
  searchLatLngValue: createCustomIcon('searchLatLngValue'),
};

function createCustomIcon(
  type:
    | 'generalIcon'
    | 'generalIconSelected'
    | 'charging'
    | 'chargingSelected'
    | 'fueling'
    | 'fuelingSelected'
    | 'parking'
    | 'parkingSelected'
    | 'maintenance'
    | 'maintenanceSelected'
    | 'inspection'
    | 'inspectionSelected'
    | 'searchLatLngValue',
) {
  // 保修/驗車沒有專屬圖騰，沿用通用地點圖標（圓形定位點），靠顏色區分。
  const isGeneralShape =
    type === 'generalIcon' ||
    type === 'generalIconSelected' ||
    type === 'maintenance' ||
    type === 'maintenanceSelected' ||
    type === 'inspection' ||
    type === 'inspectionSelected';

  const iconPath = isGeneralShape
    ? 'M 480 -480 q 33 0 56.5 -23.5 T 560 -560 q 0 -33 -23.5 -56.5 T 480 -640 q -33 0 -56.5 23.5 T 400 -560 q 0 33 23.5 56.5 T 480 -480 Z m 0 294 q 122 -112 181 -203.5 T 720 -552 q 0 -109 -69.5 -178.5 T 480 -800 q -101 0 -170.5 69.5 T 240 -552 q 0 71 59 162.5 T 480 -186 Z m 0 106 Q 319 -217 239.5 -334.5 T 160 -552 q 0 -150 96.5 -239 T 480 -880 q 127 0 223.5 89 T 800 -552 q 0 100 -79.5 217.5 T 480 -80 Z m 0 -480 Z'
    : type === 'charging' || type === 'chargingSelected'
      ? 'm480-336 128-184H494l80-280H360v320h120v144ZM400-80v-320H280v-480h400l-80 280h160L400-80Zm80-400H360h120Z'
      : type === 'fueling' || type === 'fuelingSelected'
        ? 'M160-120v-640q0-33 23.5-56.5T240-840h240q33 0 56.5 23.5T560-760v280h40q33 0 56.5 23.5T680-400v180q0 17 11.5 28.5T720-180q17 0 28.5-11.5T760-220v-288q-9 5-19 6.5t-21 1.5q-42 0-71-29t-29-71q0-32 17.5-57.5T684-694l-84-84 42-42 148 144q15 15 22.5 35t7.5 41v380q0 42-29 71t-71 29q-42 0-71-29t-29-71v-200h-60v300H160Zm80-440h240v-200H240v200Zm480 0q17 0 28.5-11.5T760-600q0-17-11.5-28.5T720-640q-17 0-28.5 11.5T680-600q0 17 11.5 28.5T720-560ZM240-200h240v-280H240v280Zm240 0H240h240Z'
        : type === 'parking' || type === 'parkingSelected'
          ? 'M600-520h60v-80h80q25 0 42.5-17.5T800-660v-40q0-25-17.5-42.5T740-760H600v240Zm60-140v-40h80v40h-80ZM520-400q-33 0-56.5-23.5T440-480v-320q0-33 23.5-56.5T520-880h320q33 0 56.5 23.5T920-800v320q0 33-23.5 56.5T840-400H720v280h-80v-280H520Zm0-80h320v-320H520v320Zm160-160ZM320-120q-17 0-28.5-11.5T280-160v-40H80v-80h240v-200H80v-80h208l-42-120H80v-80h180q19 0 34.5 11t21.5 29l84 240v320q0 17-11.5 28.5T360-120h-40ZM220-320q25 0 42.5-17.5T280-380q0-25-17.5-42.5T220-440q-25 0-42.5 17.5T160-380q0 25 17.5 42.5T220-320Z'
          : 'M 480 -480 q 33 0 56.5 -23.5 T 560 -560 q 0 -33 -23.5 -56.5 T 480 -640 q -33 0 -56.5 23.5 T 400 -560 q 0 33 23.5 56.5 T 480 -480 Z m 0 294 q 122 -112 181 -203.5 T 720 -552 q 0 -109 -69.5 -178.5 T 480 -800 q -101 0 -170.5 69.5 T 240 -552 q 0 71 59 162.5 T 480 -186 Z m 0 106 Q 319 -217 239.5 -334.5 T 160 -552 q 0 -150 96.5 -239 T 480 -880 q 127 0 223.5 89 T 800 -552 q 0 100 -79.5 217.5 T 480 -80 Z m 0 -480 Z';

  const isSelected =
    type === 'generalIconSelected' ||
    type === 'chargingSelected' ||
    type === 'fuelingSelected' ||
    type === 'parkingSelected' ||
    type === 'maintenanceSelected' ||
    type === 'inspectionSelected';

  const circleFill = 'white';
  const circleStroke = isSelected ? '#ff0000' : '#e0e0e0';
  const pathFill = isSelected
    ? '#ff0000'
    : type === 'maintenance'
      ? '#BE4BDB'
      : type === 'inspection'
        ? '#15AABF'
        : '#007AFF';

  const placeSvg = `
    <svg width="${ICON_SIZE}" height="${ICON_SIZE}" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="${ICON_SIZE / 2}"
        cy="${ICON_SIZE / 2}"
        r="${ICON_SIZE / 2 - 3}"
        fill="${circleFill}"
        stroke="${circleStroke}"
        stroke-width="2"
      />
      <svg x="${(ICON_SIZE - 20) / 2}" y="${(ICON_SIZE - 20) / 2}" width="20" height="20" viewBox="0 -960 960 960">
        <path d="${iconPath}" fill="${pathFill}" />
      </svg>
    </svg>
  `;

  const latLngMarkerSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${ICON_SIZE}" height="${ICON_SIZE}" viewBox="0 0 24 24">
      <!-- 外層紅色 pin -->
      <path fill="#e4442fff" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
      <!-- 中心圓點 -->
      <circle cx="12" cy="9" r="2.5" fill="#8B0000" />
    </svg>
  `;

  if (type === 'searchLatLngValue') {
    return (
      'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(latLngMarkerSvg)
    );
  } else {
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(placeSvg);
  }
}

// 圖標 & 地點資訊列表管理
interface MapPinsProps {
  places: PlaceWithServices[]; // 所有地點
  selectedLocation?: PlaceWithServices | null; // 選定的地點
  searchServiceType?: string[] | null;
  searchLatLngValue?: string | null; // 搜尋的經緯度數值
  setSelectedLocation?: (place: PlaceWithServices) => void; // 點擊圖標
  isNearbyPlacesListOpen: boolean; // 附近場站列表的開啟／收合狀態
  defaultCenterSelectedZoom: number;
  setHasUserMovedMap: (hasUserMoved: boolean) => void;
}

const MapPins: React.FC<MapPinsProps> = ({
  places,
  selectedLocation,
  searchServiceType,
  searchLatLngValue,
  setSelectedLocation,
  isNearbyPlacesListOpen,
  defaultCenterSelectedZoom,
  setHasUserMovedMap,
}) => {
  const map = useMap();

  const handleMarkerClick = (place: PlaceWithServices) => {
    flushSync(() => setSelectedLocation(null));
    flushSync(() => setSelectedLocation(place));

    // 設定地圖中心點
    map.setCenter({
      lat: place.location.lat,
      lng: place.location.lng,
    });
    if ((map.getZoom() ?? 0) < defaultCenterSelectedZoom) {
      map.setZoom(defaultCenterSelectedZoom);
    }
    // 資訊卡牌再選定地點時預設都會展開, 故要把地圖中心稍微移動, 以避免被遮蓋住
    map.panBy(-170, 0);
    // 如果附近場站卡牌也有展開, 就需要另外再 panBy -200
    if (isNearbyPlacesListOpen) map.panBy(-200, 0);

    setHasUserMovedMap(false);
  };

  const getIcon = (isSelected: boolean): string => {
    if (searchServiceType && searchServiceType.length === 1) {
      const type = searchServiceType[0];
      if (type === 'CHARGING')
        return isSelected ? iconCache.chargingSelected : iconCache.charging;
      if (type === 'FUELING')
        return isSelected ? iconCache.fuelingSelected : iconCache.fueling;
      if (type === 'PARKING')
        return isSelected ? iconCache.parkingSelected : iconCache.parking;
      if (type === 'MAINTENANCE')
        return isSelected
          ? iconCache.maintenanceSelected
          : iconCache.maintenance;
      if (type === 'INSPECTION')
        return isSelected ? iconCache.inspectionSelected : iconCache.inspection;
    }
    return isSelected ? iconCache.generalIconSelected : iconCache.generalIcon;
  };

  const CustomMarkers = places.map((place) => {
    const isSelected = selectedLocation?.id === place.id;
    const icon = getIcon(isSelected);

    return (
      <AdvancedMarker
        key={place.id}
        position={{
          lat: place.location.lat,
          lng: place.location.lng,
        }}
        onClick={() => handleMarkerClick(place)}
      >
        <img src={icon} alt={place.name} style={{ width: 40, height: 40 }} />
      </AdvancedMarker>
    );
  });

  return (
    <>
      {CustomMarkers}

      {searchLatLngValue &&
        (() => {
          const [lat, lng] = searchLatLngValue
            .replaceAll(' ', '')
            .split(',')
            .map(parseFloat);
          return (
            <AdvancedMarker
              key={`search-${lat}-${lng}`}
              position={{ lat, lng }}
            >
              <img
                src={iconCache.searchLatLngValue}
                alt={searchLatLngValue}
                style={{ width: 40, height: 40 }}
              />
            </AdvancedMarker>
          );
        })()}

      {/* 固定在地圖左方的資訊卡片 */}
      {selectedLocation && (
        <PlaceServicesSummary
          isNearbyPlacesListOpen={isNearbyPlacesListOpen}
          selectedLocation={selectedLocation}
          setSelectedLocation={setSelectedLocation}
        />
      )}
    </>
  );
};

export default MapPins;
